export const newsData = [
  {
    id: 1,
    date: '2025.01.15',
    category: 'お知らせ',
    title: '年末年始の営業時間のお知らせ',
  },
  {
    id: 2,
    date: '2024.12.20',
    category: 'サービス',
    title: '新しいレーザー印刷機を導入しました',
  },
  {
    id: 3,
    date: '2024.12.10',
    category: '実績',
    title: '地元高校の卒業記念品を制作させていただきました',
  },
  {
    id: 4,
    date: '2024.11.25',
    category: 'キャンペーン',
    title: '冬の記念品キャンペーン実施中',
  },
];
